import {
    initMain
} from './vue/controllers/main';
import {
    header
} from './vue/controllers/header';

const mixins = [];
initMain(mixins, {
    SearchResults: () => import('./vue/components/search-results/SearchResults.vue')
}, []);
header();